import { TabLogin } from '@/types';
import { createContext, useContext } from 'react';

type ListTabContextType = {
  listTab: TabLogin[];
  setListTab: React.Dispatch<React.SetStateAction<Array<TabLogin>>>;
  /** Đã biết quyền của người dùng hay chưa (từ cache hoặc từ API get-list-tab). */
  isListTabLoaded: boolean;
  setIsListTabLoaded: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ListTabContext = createContext<ListTabContextType | undefined>(
  undefined,
);

export const useListTab = () => {
  const context = useContext(ListTabContext);
  if (!context) throw new Error('useLogin must be used inside IsLoginProvider');
  return context;
};
